export const fire = {
    firebase: {
        apiKey: "AIzaSyAcSrtDG2sGq-smFkDe6ktOJLO8ArWhFPY",
        authDomain: "platinum-rail-service.firebaseapp.com",
        projectId: "platinum-rail-service",
        storageBucket: "platinum-rail-service.appspot.com",
        messagingSenderId: "667298465235",
        appId: "1:667298465235:web:671a99f243505b30241b26",
        measurementId: "G-WNDFG0CLL9"
    }
}               

